<template>
  <el-dialog append-to-body :close-on-click-modal="false" center :visible.sync="visible" :width="resultSt?'968px':'584px'">
    <div class="state1" v-if="!resultSt">
      <dl>
        <dt>
          <img src="~@/assets/img/worning.png"/>
        </dt>
        <dd>
          <h3>您的报告不在查询范围!</h3>
          <p>{{infoMsg}}</p>
        </dd>
      </dl>
    </div>
    <div class="state2" v-if="resultSt">
      <h3 class="title">{{title}}</h3>
      <dl>
        <div style="margin: 0 auto;" v-if="noProgress">
          <img src="@/assets/img/noData.png"/>
          <p style="font-size: 24px;font-weight: bold;margin-bottom:38px;margin-top:16px;">抱歉，暂无进度</p>
        </div>
        <dt v-if="!noProgress && reportArr.length>0">
          <p v-if="reportArr[reportIndex].reportNo" class="key">报告编号</p>
          <p v-if="reportArr[reportIndex].reportNo">{{reportArr[reportIndex].reportNo || '/'}}</p>
          <p v-if="reportArr[reportIndex].regFormNo" class="key">委托单号</p>
          <p v-if="reportArr[reportIndex].regFormNo">{{reportArr[reportIndex].regFormNo || '/'}}</p>
          <p class="key">委托单位</p>
          <p>{{reportArr[reportIndex].orgWtName || '/'}}</p>
          <p v-if="reportArr[reportIndex].orderProgress" class="key">检测进度</p>
          <p v-if="reportArr[reportIndex].orderProgress">{{reportArr[reportIndex].orderProgress || '/'}}</p>
          <p class="key">样品名称</p>
          <p>{{reportArr[reportIndex].sampleName || '/'}}</p>
          <p class="key">样品型号</p>
          <p>{{reportArr[reportIndex].specModel || '/'}}</p>
        </dt>
        <dd>
          <img v-if="reportArr.length>0 && reportArr[reportIndex].determination!=undefined" :src="setImg"/>
        </dd>
      </dl>
    </div>
    <span slot="footer" class="dialog-footer" v-if="resultSt && reportArr.length>0">
      <el-button v-if="resultSt && reportArr.length>0 && reportArr[reportIndex].repPreUri" style="font-size: 14px;" type="primary" size="small" round @click="viewPdf">报告在线预览</el-button>
      <el-button v-if="reportArr.length>1" style="font-size: 14px;" size="small" round @click="reportIndex--" :disabled="!reportIndex">上一个</el-button>
      <el-button v-if="reportArr.length>1" style="font-size: 14px;" size="small" round @click="reportIndex++" :disabled="reportIndex === reportArr.length-1">下一个</el-button>
    </span>
    <!-- <div v-if="!resultSt" class="bottom_btns">
      <el-button style="margin-right: 10px;" round @click="visible = false">取消</el-button>
      <el-button type="primary" round @click="visible = false">确认</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      resultSt: false,
      infoMsg:'',
      noProgress: false,
      reportArr:[],
      title:"",
      reportIndex:0
    };
  },
  computed:{
    setImg(){
      let url = ''
      switch (this.reportArr[this.reportIndex].determination) {
        case '/':
        url = require('@/assets/img/bpd.png')
          break;
        case '合格':
        url = require('@/assets/img/hg.png')
          break;
        case '不合格':
        url = require('@/assets/img/bhg.png')
          break;
        case '未检验':
        url = require('@/assets/img/wjy.png')
          break;
        case '问题项':
          url = require('@/assets/img/wtx.png')
          break;
        default:
          break;
      }
      return url
    }
  },
  methods: {
    init(data,st) {
      this.noProgress = false;
      this.visible = true;
      // this.title = st ? "防伪查询检验基本信息":"检测进度查询基本信息";
      this.title = "订单检测基本信息"
      this.reportIndex = 0;
      this.resultSt = data.data;
      this.infoMsg = data.msg;
      this.reportArr = data.data || [];
      if(!st && !this.reportArr[0].orderProgress){
        // 没有输报告编号时查进度且无进度
        this.noProgress = true;
      }
    },
    viewPdf(){
      // if (window.navigator.msSaveOrOpenBlob) {
      //   // IE version
      //   var blob = new Blob([this.reportObj.repPreUri], { type: 'application/force-download' })
      //     window.navigator.msSaveOrOpenBlob(blob)
      // } else {
          window.open(window.SITE_CONFIG["baseUrl"]+'/checkmall-file/api/file/previewFile?fileCode='+ this.reportArr[this.reportIndex].repPreUri);
      // }
    }
  },
};
</script>
<style lang="scss" scoped>
.state2 {
  padding-top: 36px;
  .title {
    font-size: 32px;   
    font-weight: bold;
    text-align: center;
    color: #007bc7;
  }
  dl {
    padding: 26px 90px 0 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    dt {
      p {
        font-size: 15px;
        font-weight: 400;
        color: #808080;
        margin-bottom: 16px;
      }
      .key {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 5px;
      }
    }
    dd {
      img {
        width: 138px;
        height: 122px;
      }
    }
  }
}
::v-deep .el-dialog__header{
  border-bottom: unset;
}
::v-deep .el-dialog__footer{
  border: unset;
  padding-bottom: 40px;
  .el-button{
    width: 120px;
    line-height: 38px;
  }
}
.bottom_btns{
  padding-top: 55px;
  text-align: right;
}
</style>
